import axios from '@/http/axios/index.js'


export default {
    getClients(payload) {
        return axios.get('warehouse/clients/list', { params: payload }).then(res => res.data)
    },
    updateGracePeriod(payload) {
        return axios.post('warehouse/grace_period/update', payload).then(res => res.data)
    },
}